import { Computer, DesktopMac, ExpandLess, ExpandMore, Hive, Mail, StarBorder } from '@mui/icons-material';
import { Badge, Box, Collapse, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ListSubheader, Typography } from '@mui/material';
import React, { Component } from 'react';
import Global from "../../../../customlib/Global";

class MainMenu extends Component {
    state = {
        subMenuLeadsReportOpen: false,
        subMenuDataCancelOpen: false,
        subMenuKecepatanResponOpen: false,
        subMenuDashboardTeleOpen: false,
        subMenuDataPendingOpen: false
    }

    toggleSubMenuLeadsReportOpen = () => {
        this.setState({ subMenuLeadsReportOpen: !this.state.subMenuLeadsReportOpen });
    }

    toggleSubMenuDataCancelOpen = () => {
        this.setState({ subMenuDataCancelOpen: !this.state.subMenuDataCancelOpen });
    }

    toggleSubMenuKecepatanResponOpen = () => {
        this.setState({ subMenuKecepatanResponOpen: !this.state.subMenuKecepatanResponOpen });
    }

    toggleSubMenuDashboardTeleOpen = () => {
        this.setState({ subMenuDashboardTeleOpen: !this.state.subMenuDashboardTeleOpen });
    }

    toggleSubMenuDataPendingOpen = () => {
        this.setState({ subMenuDataPendingOpen: !this.state.subMenuDataPendingOpen });
    }

    render() {
        return (
            <>
                <Box>
                    <Typography variant="h6" gutterBottom component="div" sx={{ p: 2, pb: 0 }}>
                        Lotus Mobile
                    </Typography>
                </Box>
                {/* {this.props.children} */}
                {/* <Box sx={{width: "100vw"}}>
                    <ConversationSearch isMobile={true} onCloseSearch={this.toggleDrawer(anchor, false)}/>
                </Box> */}
                <List sx={{ width: "80vw" }}>
                    <ListItem key={"menu-1"} disablePadding onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_CONTACTS)}>
                        <ListItemButton>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Contacts"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"menu-2"} disablePadding onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_HANDOVER)}>
                        <ListItemButton>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Pengalihan"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"menu-3"} disablePadding>
                        <ListItemButton onClick={this.toggleSubMenuLeadsReportOpen}>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Leads Report"} />
                            {this.state.subMenuLeadsReportOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={this.state.subMenuLeadsReportOpen} timeout="auto" unmountOnExit>
                        <ListSubheader component="div" id="nested-list-subheader">
                            By Sales
                        </ListSubheader>
                        <List component="div" disablePadding>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_LEADS_REPORT_REGULAR)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Leads Report" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DATA_CROSS_LEADS)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Data Cross Leads (Semua Data)" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DATA_REPORTING_PER_SALES)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Data Reporting Per Sales" />
                            </ListItemButton>
                        </List>
                        <Divider />
                        <List component="div" disablePadding onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_LEADS_REPORT_BY_HOURS)}>
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="By Hours" />
                            </ListItemButton>
                        </List>
                        <Divider />
                        <ListSubheader component="div" id="nested-list-subheader">
                            Summary
                        </ListSubheader>
                        <List component="div" disablePadding>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_SUMMARY_BY_SALES_LABEL_KATEGORI_KOTA)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="By Sales, Label, Kategori, Kota" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_SUMMARY_OVERVIEW_LEADS)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Overview Leads" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_SUMMARY_KATEGORI_IKLAN)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Kategori Iklan" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_SUMMARY_URL_IKLAN)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="URL Iklan" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_SUMMARY_JUMLAH_URL_IKLAN)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Jumlah URL Iklan" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_SUMMARY_SOLD_CATEGORIES)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Sold Categories" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_SUMMARY_LEADS_BY_WILAYAH)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Leads By Wilayah" />
                            </ListItemButton>
                        </List>
                        <Divider />
                        <List component="div" disablePadding onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_CHECKPOINT_REPORT)}>
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Checkpoint" />
                            </ListItemButton>
                        </List>
                        <Divider />
                        <List component="div" disablePadding onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_RIWAYAT_LABEL)}>
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Riwayat Label" />
                            </ListItemButton>
                        </List>
                        <Divider />
                        <List component="div" disablePadding onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_BY_REFERRAL)}>
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="By Referral" />
                            </ListItemButton>
                        </List>
                        <Divider />
                        <List component="div" disablePadding onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_LEADS_MONITORING)}>
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Leads Monitoring" />
                            </ListItemButton>
                        </List>
                        {/* <ListSubheader component="div" id="nested-list-subheader">
                            Leads Monitoring
                        </ListSubheader>
                        <List component="div" disablePadding>
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Autoleads ON/OFF" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Autoleads History" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Leads Pending" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Urutan leads" />
                            </ListItemButton>
                        </List> */}
                    </Collapse>
                    <ListItem key={"menu-4"} disablePadding>
                        <ListItemButton onClick={this.toggleSubMenuDataCancelOpen}>
                        {/* <ListItemButton> */}
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Data Cancel"} />
                            {this.state.subMenuDataCancelOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={this.state.subMenuDataCancelOpen} timeout={"auto"} unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_FOLLOWUP_HARIAN)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Follow Up Harian" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_FOLLOWUP_RUTIN)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Follow Up Rutin" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_REPORT_FOLLOWUP)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Report Follow Up" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_EFFECTIVITY_RATE)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Effectivity Rate" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_LEADS_PARCEL)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Leads Parcel" />
                            </ListItemButton>
                            {/* <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DATA_SAMPAH)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Data Sampah" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_RISET_1)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Riset 1" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_RISET_2)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Riset 2" />
                            </ListItemButton> */}
                        </List>
                    </Collapse>

                    <ListItem key={"menu-5"} disablePadding onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_CONVERSATION_SEARCH)}>
                        <ListItemButton>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Pencarian Contact"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"menu-6"} disablePadding>
                        <ListItemButton onClick={this.toggleSubMenuKecepatanResponOpen}>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Kecepatan Respon"} />
                            {this.state.subMenuKecepatanResponOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={this.state.subMenuKecepatanResponOpen} timeout={"auto"} unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_KECEPATAN_RESPON_BY_FIRST_RESPON)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="By First Respon" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_KECEPATAN_RESPON_AVERAGE)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Average" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_KECEPATAN_RESPON_CS_AVERAGE)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="CS Average" />
                            </ListItemButton>
                        </List>
                    </Collapse>
                    <ListItem key={"menu-7"} disablePadding>
                        <ListItemButton onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_CUSTOMER_SERVICE_HELP)}>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"CS"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"menu-8"} disablePadding>
                        <ListItemButton onClick={this.toggleSubMenuDashboardTeleOpen}>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Dashboard Tele"} />
                            {this.state.subMenuDashboardTeleOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={this.state.subMenuDashboardTeleOpen} timeout={"auto"} unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_TELE_FU_REPORT)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Fu Report" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_TELE_DICHAT_CUSTOMER)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Di Chat Customer" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_TELE_ER_REPORT)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="ER Report" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_TELE_AVERAGE)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Average Tele/Recycle" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_TELE_FIRST_RESPON_DICHAT_CUSTOMER)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="First Respon Di Chat Customer" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_TELE_AVERAGE_DICHAT_CUSTOMER)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Average Di Chat Customer" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_TELE_EFEKTIFITAS_FU)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Efektifitas FU" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_TELE_EFEKTIFITAS_FU_HSM_MARKETING)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Efektifitas HSM FU Marketing" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_TELE_EFEKTIFITAS_HSM)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Efektifitas HSM" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_TELE_KEDISIPLINAN_FU)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Kedisiplinan FU" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_TELE_RESUME_KEDISIPLINAN_FU)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Resume Kedisiplinan FU" />
                            </ListItemButton>
                        </List>
                    </Collapse>
                    <ListItem key={"menu-9"} disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Pesan Belum Direspon Sales"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"menu-10"} disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Data Cancel"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"menu-11"} disablePadding onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DAILY_CLOSING_RATE)}>
                        <ListItemButton>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Closing Rate"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"menu-12"} 
                        disablePadding
                        onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_SOLUSI_DATA_CANCEL)}
                        >
                        <ListItemButton>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Dashboard Solusi Data Cancel"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"menu-13"}
                        disablePadding
                        onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_INBOX_DIBACA_BELUM_RESPON)}
                        secondaryAction={this.props.listJustRead.length > 0 ? (
                            <Badge badgeContent={this.props.listJustRead.length} color="secondary">
                                <Mail />
                            </Badge>
                        ) : (<></>)}
                    >
                        <ListItemButton>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Inbox Dibaca tapi Belum Direspon"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"menu-14"} disablePadding onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_RIWAYAT_PERPINDAHAN_CONTACT)}>
                        <ListItemButton>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Riwayat Perpindahan Contact"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"menu-15"} disablePadding onClick={this.toggleSubMenuDataPendingOpen}>
                        <ListItemButton>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Leads Data Pending"} />
                            {this.state.subMenuDashboardTeleOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={this.state.subMenuDataPendingOpen} timeout={"auto"} unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DATA_PENDING_LEADS)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Data Pending Leads" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DATA_PENDING_LEADS_PARCEL_EVENT)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Leads Parcel Event" />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DATA_PENDING_LEADS_BELUM_ADA_LABEL)}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Leads Belum Ada Label" />
                            </ListItemButton>
                        </List>
                    </Collapse>
                    <ListItem key={"menu-16"} 
                        disablePadding
                        onClick={() => this.props.onMenuSelected(Global.DRAWER_MODE_DASHBOARD_PERFORMA_SALES)}
                    >
                        <ListItemButton>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Dashboard Performa Sales"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"menu-17"} disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <Hive />
                            </ListItemIcon>
                            <ListItemText primary={"Wajib Bayar"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"menu-18"} disablePadding>
                        <ListItemButton color='error' onClick={this.props.enableDesktopMode}>
                            <ListItemIcon color='error'>
                                <Computer />
                            </ListItemIcon>
                            <ListItemText color='error' primary={"Enable Desktop Mode"} />
                        </ListItemButton>
                    </ListItem>
                </List>
                {/* <MenuList sx={{width: "80vw"}}>
                    <MenuItem>
                        <ListItemIcon>
                            <ContentCut fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Cut</ListItemText>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            ⌘X
                        </Typography>
                    </MenuItem>
                    <MenuItem>
                        <ListItemIcon>
                            <ContentCopy fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Copy</ListItemText>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            ⌘C
                        </Typography>
                    </MenuItem>
                    <MenuItem>
                        <ListItemIcon>
                            <ContentPaste fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Paste</ListItemText>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            ⌘V
                        </Typography>
                    </MenuItem>
                    <Divider />
                    <MenuItem>
                        <ListItemIcon>
                            <Cloud fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Web Clipboard</ListItemText>
                    </MenuItem>
                </MenuList> */}
            </>
        );
    }
}

export default MainMenu;